/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo, useCallback } from 'react'
import { useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@progress/kendo-react-dialogs'

import DocumentPanelView from '../../views/document-panel/document-panel.view'
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { ButtonHLPure, DialogSystemGLPure } from '../../pures'
import { b64toBlob } from '../../../validators'
import { DigitalVaultService, LocalStorageService } from '../../../services'
import localStorageService from '../../../services/localStorage.service'

const DocumentPanelAction = (props) => {
  let {
    documentData,
    handleEditDoc,
    handlePrintDoc,
    handleSendEmailDoc,
    handleShareDoc,
    handleDeleteDoc,
    handleVersionDoc,
    handleSignRequest,
    permissions,
    signedInGovo,
    url,
    toggleLoadingRequesting,
    handleFile,
    selectedFileName,
    selectedFile,
    handleDeleteFile,
    handleCloseDialogVersion,
    handleShowDialogVersion,
    showDialogVersion,
    setShowDialogVersion,
    errorFile,
    selectedFileBase64,
    handleDownloadDoc,
    fileExpSelected,
    userCollaborators,
    toggleErrorRequesting,
    fromDelete,
    handleRestoreDocument,
    handleDeletePermanently,
    isEditing,
    onToggleEdit,
    onRequestSave,
    handleReturn,
    isDeletingDocument = false,
    toggleCompletedRequesting
  } = props

  const { t } = useTranslation()

  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false)

  const handleLocalRestoreDocument = useCallback(async () => {
    try {
      toggleLoadingRequesting(true)

      if (handleRestoreDocument) {
        await handleRestoreDocument(documentData.id)
      } else {
        const digitalVaultService = new DigitalVaultService(process.env.REACT_APP_MIFIRMA_API)
        const tokenData = localStorageService.getLocalStorageItem("token")
        const token = tokenData?.idToken

        if (!token) {
          throw new Error('No se encontró token de autenticación')
        }

        if (!isDeletingDocument) {
          await digitalVaultService.startDeleteWorkflow(documentData.id, false, token)
        } else {
          await digitalVaultService.nextDeleteWorkflowStep(documentData.id, token, false)
        }
      }
      toggleCompletedRequesting(4000, true, '/')
      toggleLoadingRequesting(false)
    } catch (error) {
      console.error('Error al restaurar documento:', error)
      toggleLoadingRequesting(false)
      if (toggleErrorRequesting) {
        toggleErrorRequesting('Error al restaurar el documento', 4000, false)
      }
    }
  }, [toggleLoadingRequesting, handleRestoreDocument, documentData, toggleErrorRequesting, isDeletingDocument])


  const handleLocalDeletePermanently = async () => {
    try {
      toggleLoadingRequesting(true)

      const digitalVaultService = new DigitalVaultService(process.env.REACT_APP_MIFIRMA_API)
      const localStorageService = new LocalStorageService()
      const tokenData = localStorageService.getLocalStorageItem("token")
      const token = tokenData?.idToken;

      if (!token) throw new Error('No se encontró token de autenticación')

      if (!isDeletingDocument) {
        await digitalVaultService.startDeleteWorkflow(documentData.id, true, token)
      } else {
        await digitalVaultService.nextDeleteWorkflowStep(documentData.id, token, true)
      }

      toggleCompletedRequesting(4000, true, '/')
    } catch (error) {
      console.error('Error al eliminar documento permanentemente:', error)
    } finally {
      toggleLoadingRequesting(false)
    }
  };


  const handleLocalGoBackToInbox = useCallback(() => {
    const hash = window.location.hash || ''
    const isBinContext = hash.includes('papelera') || hash.includes('bin') || hash.includes('/digital-vault/bin') || fromDelete === true
    if (isBinContext) {
      if (typeof props.goBack === 'function') {
        props.goBack()
      }
      window.location.hash = '/digital-vault/bin'
    } else {
      window.location.hash = '/'
    }
  }, [props.goBack, fromDelete])

  const handleShowDeleteConfirmModal = useCallback(() => {
    setShowDeleteConfirmModal(true)
  }, [])


  const handleCloseDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false)
  }

  const handleConfirmDeletePermanently = () => {
    setShowDeleteConfirmModal(false)
    handleLocalDeletePermanently()
  }
  const permissionsCheckBox = useMemo(() => [
    {
      name: t('documentPanelActions.alerts'),
      value: false,
      nameBD: 'alerts',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_ALERTS}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.edit'),
      value: false,
      nameBD: 'editMetadata',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_EDIT}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.print'),
      value: false,
      nameBD: 'print',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_PRINT}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.download'),
      value: false,
      nameBD: 'download',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_DOWNLOAD}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.delete'),
      value: false,
      nameBD: 'delete',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_TRASH}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.share'),
      value: false,
      nameBD: 'share',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SHARE}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.send'),
      value: false,
      nameBD: 'sendMail',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SEND}`,
      checked: false,
    },
    {
      name: 'Solicitud de firma',
      value: false,
      nameBD: 'signRequest',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SIGN_REQUEST}`,
      checked: false,
    }
  ], [t])

  const deleteRequestActions = useMemo(() => [
    {
      name: t('digitalVaultBinView.grid.btns.restore'),
      value: false,
      nameBD: 'restore',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_RESTORE}`,
      checked: false,
      handler: handleLocalRestoreDocument
    },
    {
      name: t('digitalVaultBinView.grid.btns.delete'),
      value: false,
      nameBD: 'deletePermanently',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_TRASH}`,
      checked: false,
      handler: handleShowDeleteConfirmModal
    },
    {
      name: t('button.return'),
      value: false,
      nameBD: 'goBack',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_SIGN_REQUEST_BACK}`,
      checked: false,
      handler: handleLocalGoBackToInbox
    }
  ], [t, handleLocalRestoreDocument, handleLocalGoBackToInbox, handleShowDeleteConfirmModal])

  const [urlDocs, setUrlDocs] = useState('')
  const [showDialogSendEmail, setShowDialogSendEmail] = useState(false)
  const [email, setEmail] = useState('')
  const [messageEmail, setMessageEmail] = useState('')
  const [errorInput, setErrorInput] = useState(false)
  const [errorInputText, setErrorInputText] = useState('')
  const [errorInputArea, setErrorInputArea] = useState(false)
  const [errorTextArea, setErrorTextArea] = useState('')
  const [blobUrl, setBlobUrl] = useState('')
  const [showDialogShare, setShowDialogShare] = useState(false)
  const [usersSend, setUsersSend] = useState('')
  const [messageShare, setMessageShare] = useState('')
  const [errorInputShare, setErrorInputShare] = useState(false)
  const [errorInputTextShare, setErrorInputTextShare] = useState('')
  const [usersSendGrid, setUsersSendGrid] = useState([])
  const [userSendGridSelected, setUserSendGridSelected] = useState({})
  const [usersChip, setUsersChip] = useState([])
  const [showDeleteDocument, setShowDeleteDocument] = useState(false)
  const [showDialogPrint, setShowDialogPrint] = useState(false)
  const [userSearch, setUserSearch] = useState('')
  const [usersGrid, setUsersGrid] = useState([])
  const [permisos, setPermisos] = useState([])

  useEffect(() => {
    const currentPath = window.location.hash || window.location.pathname
    const isInBin = currentPath.includes('papelera') ||
      currentPath.includes('bin') ||
      currentPath.includes('/digital-vault/bin') ||
      documentData?.status === process.env.REACT_APP_DOCUMENT_STATUS_ELIMINADO

    const isFromDeleteRequest = fromDelete === true

    let currentActions
    if (isInBin || isFromDeleteRequest) {
      currentActions = deleteRequestActions
    } else {
      currentActions = permissionsCheckBox
    }

    setPermisos(currentActions)
  }, [fromDelete, deleteRequestActions, permissionsCheckBox, documentData, t])

  const permissionsObject = useMemo(() => {
    const currentPath = window.location.hash || window.location.pathname
    const isInBin = currentPath.includes('papelera') ||
      currentPath.includes('bin') ||
      currentPath.includes('/digital-vault/bin') ||
      documentData?.status === process.env.REACT_APP_DOCUMENT_STATUS_ELIMINADO

    const isFromDeleteRequest = fromDelete === true

    if (isInBin || isFromDeleteRequest) {
      return {
        alerts: false,
        print: false,
        download: false,
        send: false,
        share: false,
        edit: false,
        delete: false,
        signRequest: false
      }
    } else {
      return permissions || {
        alerts: true,
        print: true,
        download: true,
        send: true,
        share: true,
        edit: true,
        delete: true,
        signRequest: true
      }
    }
  }, [fromDelete, permissions, documentData])

  const mobileResolution = useMediaQuery('(max-width:560px)')
  const is2000 = useMediaQuery('(max-width:2000px)')
  const is1500 = useMediaQuery('(max-width:1500px)')
  const is1366 = useMediaQuery('(max-width:1366px)')
  let heightContainer = mobileResolution ? 450 : 800
  let widthContainer = mobileResolution ? 550 : 1000
  let heightBody = mobileResolution ? 230 : 400

  if (is2000) {
    heightBody = 550
  }

  if (is1500) {
    heightBody = 500
  }

  if (is1366) {
    heightContainer = 700
    heightBody = 420
  }

  const pdf = useMemo(
    () => (
      <PdfReader
        className='pdfReader'
        file={selectedFileBase64}
        isFile
        src={`data:application/pdfbase64,${selectedFileBase64}`}
      ></PdfReader>
    ),
    [selectedFileBase64]
  )

  useEffect(() => {
    if (selectedFileBase64) {
      const blob = b64toBlob(selectedFileBase64, 'application/pdf')
      setBlobUrl(blob)
    }
  }, [selectedFileBase64])

  useEffect(() => {
    if (!url) return
    setUrlDocs(url)
  }, [url])

  useEffect(() => {
    if (!userCollaborators || userCollaborators.length === 0) return
    setUsersGrid(userCollaborators)
  }, [userCollaborators])

  useEffect(() => {
    if (!userSearch) return
    let usersFilter = userCollaborators.filter(
      (item) =>
        item.name.toLowerCase().includes(userSearch.toLowerCase()) ||
        item.email.toLowerCase().includes(userSearch.toLowerCase())
    )
    setUsersGrid(usersFilter)
  }, [userSearch])

  const handleShowDialog = () => {
    setShowDialogSendEmail(true)
  }

  const handleCloseDialog = () => {
    setShowDialogSendEmail(false)
  }

  const handleChangeEmail = (e) => {
    setErrorInputText('')
    setErrorInput(false)
    let value = e.target.value
    value = value ? value : ''

    setEmail(value)
  }

  const handleChangeMessageEmail = (e) => {
    setErrorTextArea('')
    setErrorInputArea(false)
    let value = e.target.value
    value = value ? value : ''

    setMessageEmail(value)
  }

  const handleSubmitDialog = () => {
    if (!email || email === '' || !messageEmail || messageEmail === '') {
      let messageError =
        !email || email === ''
          ? 'Es obligatorio agregar un correo'
          : 'Es obligatorio agregar un mensaje'
      if (!email || email === '') {
        messageError = 'Es obligatorio agregar un correo'
        setErrorInputText(messageError)
        setErrorInput(true)
      }

      if (!messageEmail || messageEmail === '') {
        messageError = 'Es obligatorio agregar un mensaje'
        setErrorTextArea(messageError)
        setErrorInputArea(true)
      }
      return
    }

    setShowDialogSendEmail(false)
    toggleLoadingRequesting(true)
    let emails = email
    let documentId = documentData.id
    let comments = messageEmail
    let fileIdExp = null
    if (documentData.infoType === 'Expediente') {
      fileIdExp = fileExpSelected.id
    }

    handleSendEmailDoc(
      emails,
      documentId,
      comments,
      setEmail,
      setMessageEmail,
      fileIdExp
    )
  }

  const handleOpenCloseDialogShare = () => {
    setErrorInputTextShare('')
    setErrorInputShare(false)
    setShowDialogShare(!showDialogShare)
  }

  const handleSubmitDialogShare = (e) => {
    if (!usersSendGrid || usersSendGrid.length === 0) {
      let messageError = 'Es obligatorio seleccionar un usuario'
      toggleLoadingRequesting(false)
      toggleErrorRequesting(messageError, 4000, false)
      return
    }

    let users = [...usersSendGrid]
    users = users.map((user) => {
      user.permissions = [...permisos]
      return user
    })
    let documentId = documentData.id
    handleShareDoc(
      users,
      documentId,
      setUsersSend,
      setUsersSendGrid,
      setUsersChip,
      setShowDialogShare,
      setMessageShare
    )
  }

  const handleShowDialogDelete = () => {
    setShowDeleteDocument(true)
  }

  const handleCloseDialogDelete = () => {
    setShowDeleteDocument(false)
  }

  const handleDeleteDocument = () => {
    setShowDeleteDocument(false)
    handleDeleteDoc()
  }

  const handleShowDialogPrint = (e, isDocument) => {
    handlePrintDoc(e, documentData, isDocument)
  }

  const handleCloseDialogPrint = () => {
    setShowDialogPrint(false)
  }

  const filterChangeUsers = (e) => {
    setUserSearch(e.target.value)
  }

  const onChangeCheckShare = (e, userSelected) => {
    let checked = e.target.checked
    let copyUsers = [...userCollaborators]
    let copyUsersSend = [...usersSendGrid]

    let usersChecked = copyUsers.map((user) => {
      if (user.email === userSelected.email) {
        user.checked = checked
      }
      return user
    })

    let newUsersSend = []
    if (checked) {
      copyUsersSend.push(userSelected)
      newUsersSend = [...copyUsersSend]
    } else {
      newUsersSend = copyUsersSend.filter(
        (user) => user.email !== userSelected.email
      )
    }

    setUsersSendGrid(newUsersSend)
    setUsersGrid(usersChecked)
  }

  const onClickBtnActions = (e, action) => {
    if (isDeletingDocument) {
      const isDelete = action.name === t('digitalVaultBinView.grid.btns.delete')
      if (isDelete && !fromDelete) return
      if (isDelete && fromDelete) {
        setShowDeleteConfirmModal(true)
        return
      }
    }
    if (action.handler) {
      action.handler()
      return
    }

    let newPermisos = permisos.map((permiso) => {
      if (permiso.name === action.name) {
        permiso.value = !permiso.value
        permiso.checked = !permiso.checked
      }

      return permiso
    })

    setPermisos(newPermisos)
  }

  const handleChangeMessageShare = (e) => {
    let value = e.target.value
    setMessageShare(value)
  }

  const handlers = {
    handleDeleteDoc,
    handleDeleteFile,
    handleDownloadDoc,
    handleEditDoc,
    handleFile,
    handlePrintDoc,
    handleSendEmailDoc,
    handleShareDoc,
    handleSignRequest,
    handleVersionDoc,
    handleChangeMessageShare,
    handleCloseDialog,
    handleChangeEmail,
    handleChangeMessageEmail,
    handleCloseDialogDelete,
    handleCloseDialogPrint,
    handleCloseDialogVersion,
    handleDeleteDocument,
    handleOpenCloseDialogShare,
    handleShowDialog,
    handleShowDialogDelete,
    handleShowDialogPrint,
    handleShowDialogVersion,
    handleSubmitDialog,
    handleSubmitDialogShare,
    filterChangeUsers,
    onChangeCheckShare,
    onClickBtnActions,
    handleReturn
  }

  const handleBack = () => {
    if (props.goBack) {
      props.goBack()
    } else {
      window.location.hash = '/digital-vault/bin'
    }
  }

  if (isDeletingDocument && !fromDelete) {
    return (
      <DialogSystemGLPure
        showInfoRequesting={true}
        infoTitle={t('digitalVaultBinView.deletingFlow.modal.title')}
        infoMessage={t('digitalVaultBinView.deletingFlow.modal.message')}
        labelInfoBtn={t('digitalVaultBinView.return.modal')}
        handleInfoClose={handleBack}
      />
    )
  }


  return (
    <>
      <DocumentPanelView
        {...props}
        blobUrl={blobUrl}
        documentData={documentData}
        email={email}
        errorFile={errorFile}
        errorInput={errorInput}
        errorInputArea={errorInputArea}
        errorInputText={errorInputText}
        errorTextArea={errorTextArea}
        fileExpSelected={fileExpSelected}
        filterChangeUsers={filterChangeUsers}
        handlers={handlers}
        heightBody={heightBody}
        heightContainer={heightContainer}
        messageEmail={messageEmail}
        messageShare={messageShare}
        onChangeCheckShare={onChangeCheckShare}
        onClickBtnActions={onClickBtnActions}
        pdf={pdf}
        permisos={permisos}
        permissions={permissionsObject}
        selectedFile={selectedFile}
        selectedFileBase64={selectedFileBase64}
        selectedFileName={selectedFileName}
        setShowDialogVersion={setShowDialogVersion}
        showDeleteDocument={showDeleteDocument}
        showDialogPrint={showDialogPrint}
        showDialogSendEmail={showDialogSendEmail}
        showDialogShare={showDialogShare}
        showDialogVersion={showDialogVersion}
        signedInGovo={signedInGovo}
        userSearch={userSearch}
        usersChip={usersSendGrid}
        userSendGridSelected={userSendGridSelected}
        usersGrid={usersGrid}
        widthContainer={widthContainer}
        showDeleteConfirmModal={showDeleteConfirmModal}
        handleShowDeleteConfirmModal={handleShowDeleteConfirmModal}
        handleCloseDeleteConfirmModal={handleCloseDeleteConfirmModal}
        handleConfirmDeletePermanently={handleConfirmDeletePermanently}
      />

      {showDeleteConfirmModal && (
        <DialogSystemGLPure
          showConfirm={true}
          confirmTitle={isDeletingDocument ? t('dialogSystemGLPure.confirmPermanentDelete.title') : t('dialogSystemGLPure.confirmDeleteFlow.title')}
          confirmMessage={isDeletingDocument ? t('dialogSystemGLPure.confirmPermanentDelete.message') : t('dialogSystemGLPure.confirmDeleteFlow.message')}
          labelCancelConfirmation={t('button.cancel')}
          labelSubmitConfirmation={isDeletingDocument ? t('button.delete') : t('dialogSystemGLPure.confirmDeleteFlow.submit')}
          handleConfirmDeleteFlowClose={handleCloseDeleteConfirmModal}
          handleConfirmDeleteFlowSubmit={handleConfirmDeletePermanently}
        />
      )}
    </>
  )
}

export default DocumentPanelAction